// extracted by mini-css-extract-plugin
module.exports = {"root":"_1I1Wt","starRating":"_3yoIm","starRatingCount":"_2jw0T"};